import React from "react";
import ComponentsFirst from "../../components/compo-1";
import Footer from "../../components/footer2";
import LastComponent from "../../components/last-component/index";
import Navbar22 from "../../components/navbar";
import Transition from "../../components/transition";
import Toggle3466 from "../../components/transition233";
import TransitionTwo from "../../components/transitonTwo";
import "./style.css";

function LandingPage() {
  return (
    <>
      <div className="mainbg" style={{ overflowX: "hidden" }}>
        <Navbar22 />
        <ComponentsFirst />
        <TransitionTwo />
      </div>
      <div style={{ marginTop: "10rem" }}>
        <Toggle3466 />
        <br />
        <br />
        <br />
        {/* <Transition /> */}
        <LastComponent />
      </div>
      <Footer />
    </>
  );
}

export default LandingPage;
